module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("1.")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("his morning Rino telephoned. I thought he wanted money again and I was ready to say no. But that was not the reason for the phone call: his mother was gone. ")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Since when?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Since two weeks ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“And you’re calling me now?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("My tone must have seemed hostile, even though I wasn’t angry or offended; there was just a touch of sarcasm. He tried to respond but he did so in an awkward, muddled way, half in dialect, half in Italian. He said he was sure that his mother was wandering around Naples as usual.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Even at night?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“You know how she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“I do, but does two weeks of absence seem normal?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Yes. You haven’t seen her for a while, Elena, she’s gotten worse: she’s never sleepy, she comes in, goes out, does what she likes.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("Anyway, in the end he had started to get worried. He had asked everyone, made the rounds of the hospitals: he had even gone to the police. Nothing, his mother wasn’t anywhere. What a good son: a large man, forty years old, who hadn’t worked in his life, just a small-time crook and spendthrift. I could imagine how carefully he had done his searching. Not at all. He had no brain, and in his heart he had only himself.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“She’s not with you?” he asked suddenly. ")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("His mother? Here in Turin? He knew the situation perfectly well, he was speaking only to speak. Yes, he liked to travel, he had come to my house at least a dozen times, without being invited. His mother, whom I would have welcomed with pleasure, had never left Naples in her life. I answered:")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“No, she’s not with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“You’re sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Rino, please, I told you she’s not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Then where has she gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("He began to cry and I let him act out his desperation, sobs that began fake and became real. When he stopped I said:")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Please, for once behave as she would like: don’t look for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Just what I said. It’s pointless. Learn to stand on your own two feet and don’t call me again, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I hung up.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6620ed8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/neapolitan-novels-boxed-set_00004.vue
// module id = 78
// module chunks = 0